import { PaymentConfigMethodOverrideDto } from 'apps/public-portal/src/app/core/api/PaymentIntegrationApiClients';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ConvenienceFeeConfigModel {
    /** Whether or not we display information about the convenience fee */
    enabled: boolean;

    /** An optional label to display instead of "Convenience Fee" to express an additional fee charged */
    label?: string;

    /** Indicative of what format the rate is given in: "percent", "flat", or "other" (not pre-calculated from a standard rate, e.g. computed per-partition by the Teller plugin) */
    format?: string;

    /** A value representing the fee in the specified format. Unused when {@link isPluginDriven} is true. */
    rate?: number;

    /** A note about the fee to be displayed in a tooltip next to the fee */
    note?: string;

    /**
     * Cart-level fee override set by a prepare endpoint that returns the
     * whole-cart total (FIS, Generic, saved-payment-method flows). Lives
     * here for delivery from {@link PaymentProcessorConfig.overrideConvenienceFee}
     * to the cart-totals aggregator; the aggregator stamps it on
     * {@link CartTotals.aggregateConvenienceFeeOverride} where the
     * <c>aggregate*</c> getters surface it. Per-partition fee math
     * (<see cref="format"/>) is bypassed when this is set.
     */
    aggregateOverride?: number | null;

    /**
     * True when the fee isn't pre-calculated from a standard rate -- the
     * backend-provided apiFee (from calculateConvenienceFee) is the final
     * amount. Today this is used by the Generic processor whose plugin
     * computes the fee per partition. Callers use this flag as a typed
     * discriminator instead of string-comparing the wire-level format.
     */
    get isPluginDriven(): boolean {
        return this.format === 'other';
    }

    fromDto(dto: PaymentConfigMethodOverrideDto) {
        this.enabled = dto.convenienceFeeEnabled;
        this.label = dto.convenienceFeeLabel;
        this.format = dto.convenienceFeeFormat;
        this.rate = dto.convenienceFeeRate;
        this.note = dto.convenienceFeeNote;
    }
}
